// frontend/src/components/GallerySection.jsx
import { useState } from "react";
import { uploadsUrl } from "../utils/api";
import "./GallerySection.css";

const GALLERY_IMAGES = [
  "amenities1.webp", "amenities2.webp", "amenities3.webp", "amenities4.webp",
  "background1.webp", "background2.webp", "background3.webp",
];

export default function GallerySection({ projectId, gallery }) {
  const { heading } = gallery;
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);

  if (!heading) return null;

  const images = GALLERY_IMAGES.map((f) => uploadsUrl(projectId, f));
  const previewImages = [
    uploadsUrl(projectId, "background1.webp"),
    uploadsUrl(projectId, "background2.webp"),
    uploadsUrl(projectId, "background3.webp"),
  ];

  const openModal = (i) => { setCurrentIdx(i); setModalOpen(true); };
  const closeModal = () => setModalOpen(false);
  const prev = () => setCurrentIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setCurrentIdx((i) => (i + 1) % images.length);

  return (
    <section className="gallery-section section" aria-labelledby="gallery-heading">
      <div className="container">
        <h2 id="gallery-heading" className="section-heading">{heading}</h2>

        <div className="gallery-grid">
          {previewImages.map((src, i) => (
            <div
              key={i}
              className={`gallery-item${i === 2 ? " gallery-item--more" : ""}`}
              onClick={() => openModal(i + 4)} // opens from background images
              role="button"
              tabIndex={0}
              aria-label={`View gallery image ${i + 1}`}
              onKeyDown={(e) => e.key === "Enter" && openModal(i + 4)}
            >
              <img src={src} alt={`Gallery ${i + 1}`} loading="lazy" />
              {i === 2 && (
                <div className="gallery-item__overlay">
                  <span>7+ More Photos</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {modalOpen && (
        <div className="gallery-modal" role="dialog" aria-modal="true" aria-label="Image gallery">
          <button className="gallery-modal__close" onClick={closeModal} aria-label="Close">×</button>
          <button className="gallery-modal__prev" onClick={prev} aria-label="Previous">&#10094;</button>
          <div className="gallery-modal__content">
            <img src={images[currentIdx]} alt={`Gallery full view ${currentIdx + 1}`} />
          </div>
          <button className="gallery-modal__next" onClick={next} aria-label="Next">&#10095;</button>
          <div className="gallery-modal__counter">{currentIdx + 1} / {images.length}</div>
        </div>
      )}
    </section>
  );
}
